import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/quests/active-quests')({
  beforeLoad: async ({ search }) => {
    search.quests = 'active-quests'
    throw redirect({ to: '/', search })
  },
})
